<template>
  <div class="dialerComp" @click="uifeedback.callsuccess = false">
    <div class="dialerHeadLine">
      <h3>Dialer</h3>
      <div>
        <i class="zmdi zmdi-chevron-down" :class="{'flip': expanded}" @click="expanded = !expanded; uifeedback.callInProgress = false"></i>
      </div>
    </div>

    <singleSelect v-if="!uifeedback.callInProgress && expanded" class="ringAtSection" name="choseRingTo" :hasIcon="false" :hasLabel="true">
      <label class='small' for='ringAt' slot="selectLabel">RING ME AT</label>
        <select class="dialerPhoneSelect" name='ringAt' id='ringAt' v-model='selected.ringTo' slot="singleSelectMain">
          <option v-for="(number, index) in availableNumbers" :value="number" slot="singleSelectOption">
            {{ formatNumber(number) }}
          </option>
        </select>
     </singleSelect>

    <div class="dialerSection">
      <inputTemplate class="fusedInput" :hasIcon="false" :hasButton="true" :hasLabel="false">
        <input type="tel" class="telephoneInput" :class="{success: uifeedback.callsuccess && uifeedback.callInProgress, errror: uifeedback.notWorkingNum && uifeedback.callInProgress, warning:callWarnings.length}" placeholder="Enter Number" @keyup="checkPhone($event)" v-model='selected.dialTo' slot="inputEl">
        <button class="solo green" :disabled="!selected.dialTo || !validNumber || uifeedback.callInProgress || !selected.locationid || !selected.ringTo" :class="{success: uifeedback.callsuccess && uifeedback.callInProgress, errror: uifeedback.notWorkingNum && uifeedback.callInProgress, warning:callWarnings.length}" @click="makeTheCall()" slot="inputBtn">
          <i class="zmdi zmdi-phone"></i>
        </button>
      </inputTemplate>

      <div v-if="callWarnings.length" class="callWarning">
        {{callWarnings}}
      </div>
      <div class="campaignSection" v-if="selectedCampaign">
        <div class="buttonWrap" v-if='this.selected.dialTo'>
          <button class="alert alt small solo" @click="rejectCall = true"><i class="zmdi zmdi-close"></i></button>
          <button class="alt small solo" @click="nextCampaignCall()"><i class="zmdi zmdi-chevron-right"></i></button>
        </div>
        <div>
          <div class="progressBar">
            <div class="progressBarFill" :style="{ width: ((selectedCampaign.callsTotal - selectedCampaign.callsRemaining - selectedCampaign.callsRejected) / selectedCampaign.callsTotal)*100 + '%' }" :refreshHack='keyHack'></div>
            <div class="progressBarFill red" :style="{ width: (selectedCampaign.callsRejected / selectedCampaign.callsTotal)*100 + '%' }" :refreshHack='keyHack'></div>
          </div>
          <div class="labels">
            <label class="small">{{selectedCampaign.callsRemaining}} CONTACTS REMAINING</label>
            <label class="small red" @click="leaveCampaign()">EXIT</label>
          </div>
        </div>
      </div>

      <div v-if="uifeedback.callInProgress && uifeedback.callsuccess" class="messageOptions disclaimer success">
        <span v-html='uifeedback.ctcResponse'></span>
      </div>

      <div v-else-if="uifeedback.callInProgress && uifeedback.notWorkingNum" class="disclaimer messageOptions error">
        The customer number you dialed is not a working number. <b>Please check the phone number and try again.</b>
      </div>
    </div>

    <div class="dialerFooter" :class="{noBorder: selectedCampaign}" v-if='this.user.frn_phonecodeid && (this.campaigns.length || multiAccount)'>
     <div class="dropdownWrapper" v-if="campaigns.length">
        <div class="fakeSelect" @click="showCampaignOptions = true">
          <span v-if="!selectedCampaign">Select Campaign</span>
          <span v-else>{{selectedCampaign.name}}</span>
        </div>
        <div class="closeSelect" @click="showCampaignOptions = false" v-if="showCampaignOptions"></div>
        <div v-if="showCampaignOptions" class="fakeSelectOptions">
          <div v-for="(campaign, index) in campaigns" class="fakeOption" @click="selectCampaign(index)" v-if="campaign.visible">
            {{campaign.name}}
            <label class="small">
              {{campaign.callsRemaining}} REMAINING
            </label>
          </div>
        </div>
     </div>
      <singleSelect v-if="multiAccount" class="dropdownWrapper" name="accountSelect" :hasIcon="true" :hasLabel="false">
        <i class="zmdi zmdi-pin" slot="icon"></i>
        <select name="dropdown" v-model='selected.locationid' slot="singleSelectMain">
          <option v-for="(account, index) in accounts" :value="account.lskinid" :selected="index === 0">
            {{ account.refname }}
          </option>
        </select>
      </singleSelect>
    </div>
    
    <article class='popupBG' v-if='rejectCall'>
      <div class='popup wide'>
        <div class='title'>
          <h2>Are you sure?</h2>
          <div class='close' @click="rejectCall = false"></div>
        </div>

        <inputTemplate class='content' :hasIcon="false" :hasLabel="true" :hasButton="false">
          <label slot="inputLabel">Reason for Removal*</label>
          <input type="text" minlength="4" v-model="rejectionReason" slot="inputEl">
        </inputTemplate>
        <div class="buttons">
          <button :disabled="rejectionReason.length < 4 || rejectionReason === ''" @click="removeContact(rejectionReason)" class="alert">REMOVE CONTACT</button>
        </div>
      </div>
      <div class='popupCloseWrap' @click="rejectCall = false" v-if="rejectCall"></div>
    </article>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex' 
import axios from 'axios';
import moment from 'moment-timezone'
import singleSelect from '@/components/singleSelect'
import inputTemplate from '@/components/inputTemplate'
require('../assets/css/dialer.css')

  export default {
    name: 'dialer',
    props: [],
    components:{
      singleSelect,
      inputTemplate
    },
    data: function () {
      return {
        expanded: true,
        availableNumbers: [],
        selected: {
          locationid: null,
          ringTo: null
        },
        uifeedback:{
          notWorkingNum: false,
          callsuccess: false,
          callInProgress: false,
          ctcResponse: ''
        },
        isInputActive: false,
        showCampaignOptions:false,
        selectedCampaign: false,
        callWarnings:'',
        rejectCall: false,
        rejectionReason:'',
        keyHack: 1
      }
    },
    mounted: function () {
      // Default location
      this.selected.locationid = this.user.frn_lskinid;
      this.pullNumbers();
      this.pullCampaigns();

      // Events
      this.$root.$on('campaignAniTrackFound', (payload) => {
        const {
          Direction,
          InteractionType,
          AgentName,
          Datetime
        } = payload;

        if (InteractionType == 'call' || InteractionType == 'text') {
          if (Direction == 'OB') {
            this.callWarnings = `${InteractionType == 'call' ? 'Called' : 'Texted'} ${AgentName ? ' by ' + AgentName : ''} at ${ this.formatDatetime(Datetime, true) } today.`
          } else {
            this.callWarnings = `Contact ${InteractionType == 'call' ? 'called' : 'texted'} in at ${ this.formatDatetime(Datetime, true) } today.`
          }
        }

        this.callWarnings;
      });
    },
    computed: {
      ...mapState({
        user: state => state.user,
        account: state => state.account,
        conversation: state => state.conversation,
        conversationOwner: state => state.conversationOwner,
        preferredOutboundDnis: state => state.preferredOutboundDnis,
        accounts: state => state.accounts,
        userProfileData: state => state.userProfileData,
        campaigns: state => state.campaigns
      }),
      ...mapGetters([
        'multiAccount'
      ]),
      validNumber: function () {
        if (this.selected.dialTo.replace(/\D/g,'').length === 10) {
          return true;
        }

        return false;
      }
    },
    watch: {
      userProfileData: {
        deep: true,
        async handler (val) {
          await this.pullNumbers();
        }
      },
      selected:{
        deep:true,
        handler(val){
          this.filterCampaigns(val.locationid);
        }
      }
    },
    methods: {
      pullCampaigns: async function () {
        await this.$store.dispatch('getCampaignData', { leuserid: this.user.leuserid, lskinid: this.user.frn_lskinid });
      },
      selectCampaign: function(index) {
        this.keyHack++;
        this.selectedCampaign = this.campaigns[index];
        this.selectedCampaign.storedCampaignIndex;
        this.showCampaignOptions = false;
        this.selectCampaignCall(this.selectedCampaign.storedCampaignIndex);
        this.selected.locationid = this.selectedCampaign.associatedLskin;
      },
      leaveCampaign:function(){
        this.selectedCampaign = false
        this.selected.dialTo = ''
        this.checkCallWarnings(false)
        //since customer is false this is called again to clear warnings

        // Clear campaign ani tracking!
        this.$root.$emit('campaignAniTrack', '');
      },
      selectCampaignCall: function (index) {
        if (this.selectedCampaign.calls.length && this.selectedCampaign.callsRemaining > 0) {
          this.checkCallWarnings(this.selectedCampaign.calls[index].CustomerNumber);
          this.selected.dialTo = this.formatNumber(this.selectedCampaign.calls[index].CustomerNumber)
          this.populateConversation();

          // Kick off event to root so we can start monitoring live calls/texts to trigger call warnings for.
          this.$root.$emit('campaignAniTrack', this.selectedCampaign.calls[index].CustomerNumber);
        } else {
          this.selected.dialTo = '';
          this.callWarnings = '';
          // Clear campaign ani tracking!
          this.$root.$emit('campaignAniTrack', '');
        }
      },
      nextCampaignCall:function(){
        if (this.selectedCampaign.callsRemaining > 0) {
          this.selectedCampaign.storedCampaignIndex++;
          this.selectedCampaign.callsRemaining--;
          this.selectCampaignCall(this.selectedCampaign.storedCampaignIndex);
        } else{
          this.leaveCampaign();
        }
      },
      formatDatetime: function (timestamp, preserve) {
        if (preserve) {
          return moment(timestamp).format('hh:mm A');
        } else {
          return moment(timestamp).add(moment.tz.zone('America/Chicago').utcOffset(moment(timestamp)) / 60, 'hours').format('hh:mm A');
        }
      },
      checkCallWarnings: async function (ani) {
        if (ani) {
          const res = await axios.get(`/calls/campaign/previousInteractions/${ani.replace(/[^0-9]/g, '')}/${this.selectedCampaign.associatedLskin}/${this.user.frn_phonecodeid}`);

          if (res.data && res.data.length) {
            const relevantInteraction = res.data[0];

            if (relevantInteraction.Direction == 'Outbound') {
              this.callWarnings = `${relevantInteraction.InteractionType == 'Call' ? 'Called' : 'Texted'} ${relevantInteraction.AgentName ? ' by ' + relevantInteraction.AgentName : ''} at ${ this.formatDatetime(relevantInteraction.Datetime, false) } today.`
            } else {
              this.callWarnings = `Contact ${relevantInteraction.InteractionType == 'Call' ? 'called' : 'texted'} in at ${ this.formatDatetime(relevantInteraction.Datetime, false) } today.`
            }
          } else {
            this.callWarnings = '';
          }

        } else {
          this.callWarnings = '';
        }
      },
      filterCampaigns: function (lskin) {
        for (const [i, campaign] of this.campaigns.entries()) {
          if (campaign.associatedLskin != lskin) {
            // Uncheck selected campaign IF location changed
            if (this.selectedCampaign.id == campaign.id) {
              this.leaveCampaign();
            }
            this.$store.commit('setCampaignVisibility', { index: i, value: false });
          } else {
            this.$store.commit('setCampaignVisibility', { index: i, value: true });
          }
        }
      },
      removeContact: async function (reason) {
        if (reason && reason.length >= 4) {
          await axios.post('/users/campaigns/removeContact', {
            campaignContactId: this.selectedCampaign.calls[this.selectedCampaign.storedCampaignIndex].CampaignContactId,
            leuserid: this.user.leuserid,
            reason: reason
          })

          this.rejectionReason = '';
          this.nextCampaignCall();
          this.rejectCall = false;
          this.selectedCampaign.callsRejected++;
        }
      },
      checkUserCampaigns: function () {
        // Pull all relevant campaigns for a given customer phonenumber -- that the logged in user has access to
        let associatedCampaigns = [];
        for (const campaign of this.campaigns) {
          for (const contact of campaign.calls) {
            // If we have a match
            if (contact.CustomerNumber == this.selectedCampaign.calls[this.selectedCampaign.storedCampaignIndex].CustomerNumber) {
              // Construct labels in the expected format for livecallmod
              const tempLabels = [];
              for (let columnNumber = 1; columnNumber <= 10; columnNumber++) {
                if (campaign[`column${columnNumber}`]) {
                  tempLabels.push({
                    label: campaign[`column${columnNumber}`],
                    data: contact[`Column${columnNumber}`]
                  })
                }
              }
              associatedCampaigns.push({
                campaignName: campaign.name,
                campaignLabels: tempLabels,
                expanded: campaign.id == this.selectedCampaign.id && contact.CampaignContactId == this.selectedCampaign.calls[this.selectedCampaign.storedCampaignIndex].CampaignContactId ? true : false
              });
            }
          }
        }
        return associatedCampaigns;
      },
      populateConversation: function () {
        if (this.selectedCampaign.calls.length) {
          const associatedCampaigns = this.checkUserCampaigns();

          this.$root.$emit('campaignConvoLoad', {
            lskin: this.selectedCampaign.associatedLskin,
            ani: this.selectedCampaign.calls[this.selectedCampaign.storedCampaignIndex].CustomerNumber,
            campaignInfo: associatedCampaigns,
				  });
        }
      },  
      formatNumber: function (number) {
        var cleaned = ('' + number).replace(/\D/g, '');
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          return match[1] + '-' + match[2] + '-' + match[3];
        }
        return null;
      },
      checkPhone: function(event) {
        this.uifeedback.notWorkingNum = false;
        this.uifeedback.callInProgress = false;
        this.uifeedback.callsuccess = false;

        // Handling for enter key
        if (event && event.keyCode == 13) {
          this.makeTheCall();
        }
      },
      logCampaignCall: async function (uniqueCallid, campaignContactId) {
        if (uniqueCallid && campaignContactId) {
          await axios.post('/calls/campaign/log', {
            UniqueCallId: uniqueCallid,
            CampaignContactId: campaignContactId
          })
        }
      },
      makeTheCall: async function () {
        if (this.selected.dialTo && this.validNumber && (this.selected.locationid || !this.multiAccount) && this.selected.ringTo) {
          this.uifeedback.callInProgress = true;
          this.expanded = false;

          await axios.get('https://partner.dialtag.com/ctc.cfm', {
            params: {
              partner: 'callbox',
              dial1: this.selected.ringTo,
              dial2: this.selected.dialTo.replace(/\D/g,''),
              lid: this.selected.locationid,
              phoneCode: this.user.frn_phonecodeid
            },
            transformRequest: [
              (data, headers) => { 
                delete headers.common.Authorization; return data 
              }
            ],
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            }
          })
          .then(async function (res) {
            this.uifeedback.ctcResponse = `
              <html>
                <p>Our system is dialing you at ${this.formatNumber(res.data.agentNumber)}. You should be getting a ring any moment. Your caller id will show ${this.formatNumber(res.data.outboundLine)}.</p>
                <p>The person you dialed will see ${res.data.callerId} as the number calling.</p>
              </html>
            `;
            this.uifeedback.callsuccess = true;

            if (this.selectedCampaign) {
              await this.logCampaignCall(res.data.callid, this.selectedCampaign.calls[this.selectedCampaign.storedCampaignIndex].CampaignContactId);
            }
          }.bind(this))
          .catch( function () {
            this.callFailed();
          }.bind(this))
        }
      },
      pullNumbers: function() {
        // This is awful, but the way the data is structured... oh well.
        let existsMap = {};
        this.availableNumbers = [];
        
        if (this.userProfileData.directPhone && !existsMap[this.userProfileData.directPhone]) {
          this.availableNumbers.push(this.userProfileData.directPhone);
          this.selected.ringTo = this.availableNumbers[0];
          this.uifeedback.userNumber = this.availableNumbers[0];
          existsMap[this.userProfileData.directPhone] = true;
        }

        if (this.userProfileData.mobilePhone && !existsMap[this.userProfileData.mobilePhone]) {
          this.availableNumbers.push(this.userProfileData.mobilePhone);
          existsMap[this.userProfileData.mobilePhone] = true;
        }

        if (this.userProfileData.deskPhone && !existsMap[this.userProfileData.deskPhone]) {
          this.availableNumbers.push(this.userProfileData.deskPhone);
          existsMap[this.userProfileData.deskPhone] = true;
        }

        if (!this.selected.ringTo && !this.uifeedback.userNumber) {
          this.selected.ringTo = this.availableNumbers[0];
          this.uifeedback.userNumber = this.availableNumbers[0];
        }
      },
      callFailed: function() {
        this.uifeedback.notWorkingNum = true;
        setTimeout(function(){ this.uifeedback.notWorkingNum = false }.bind(this), 1500);
      }
    }
  }
</script>
